export function backgroundCover() {
  return {
    restrict: 'A',
    scope: {
      backgroundCover: '<'
    },
    link
  };

  function link(scope, element) {
    let { backgroundCover } = scope;

    // Support background image as string (plain url) or object (with url and other attributes)
    let url = backgroundCover;
    let position = '50% 50%';
    if (angular.isObject(backgroundCover)) {
      url = backgroundCover.url;
      position = backgroundCover.position || position;
    }
    element.css({
      'background-image': `url(${url})`,
      'background-size': 'cover',
      'background-position': position
    });
  }
}
